import { useState } from 'react';
import { Dropdown } from '../Dropdown/Dropdown';
import { countriesArray } from '../CountrySelector/assets';
import { contacts } from './mockData';
import office from 'images/office.jpg';
import './styles.scss';

const DistributionContacts = () => {
    const [selectedCountry, setSelectedCountry] = useState('');
    const onChangeCountry = item => {
        setSelectedCountry(item.name);
        console.log('item', item.name);
    };
    return (
        <div className="container">
            <div className="distribution-contacts">
                <div className="distribution-contacts__contacts">
                    <p className="description-medium">
                        To view contacts of distributors and regional representatives, choose a country
                    </p>
                    {contacts.find(el => el.country === selectedCountry) && <p>{selectedCountry}</p>}
                    <Dropdown
                        label="PLEASE CHOOSE A COUNTRY"
                        options={countriesArray}
                        onDropdownChange={onChangeCountry}
                    />
                </div>
                <img src={office} alt="office" />
            </div>
        </div>
    );
};

export default DistributionContacts;
